import React, { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Network } from "@capacitor/network";
import { WifiOff } from "lucide-react";

// Overlay Fuma quando manca la connessione. Si chiude da solo al ritorno online (nessun riavvio).
export default function OfflineOverlay() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    let handle;
    if (Capacitor.isNativePlatform()) {
      Network.getStatus().then((s) => setOffline(!s.connected)).catch(() => {});
      Network.addListener("networkStatusChange", (s) => setOffline(!s.connected))
        .then((h) => { handle = h; }).catch(() => {});
      return () => { try { handle && handle.remove && handle.remove(); } catch (e) {} };
    }
    setOffline(!navigator.onLine);
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  if (!offline) return null;
  return (
    <div data-testid="offline-overlay" className="fixed inset-0 z-[9998] bg-[#0A0A0C]/96 backdrop-blur-sm flex flex-col items-center justify-center px-8 text-center" style={{ paddingTop: "env(safe-area-inset-top)", paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="h-16 w-16 rounded-2xl bg-[#00E676]/15 flex items-center justify-center mb-5"><WifiOff className="h-8 w-8 text-[#00E676]" /></div>
      <div className="font-['Unbounded'] font-black text-xl leading-tight">Ops, Fuma ha perso la strada 🛵</div>
      <p className="text-sm text-white/60 mt-2 max-w-xs">Controlla la connessione e riprova. Riprendo da solo appena torni online.</p>
    </div>
  );
}
